module.exports = __webpack_public_path__ + "static/voice_assistant-5c4a4a4884ff630278340ede48f811ca.jpeg";